import { Directive, HostListener, ElementRef, inject, Input } from '@angular/core';

@Directive({
  selector: '[pcAutoFocusNext]',
  standalone: true
})
export class AutoFocusNextDirective {
  @Input() index!: number;

  private el = inject(ElementRef<HTMLInputElement>);

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const inputElement: HTMLInputElement = this.el.nativeElement;
    const key = event.key;

    if (this.shouldMoveFocus(key)) {
      event.preventDefault();
      inputElement.value = key;
      inputElement.dispatchEvent(new Event('input'));
      this.moveToNextElement();
    }
  }

  @HostListener('input', ['$event'])
  onInput() {
    const inputElement: HTMLInputElement = this.el.nativeElement;
    const value = inputElement.value;

    // Condition to determine if we should move focus
    if (this.shouldMoveFocus(value)) {
      this.moveToNextElement();
    }
  }

  private shouldMoveFocus(value: string): boolean {
    return /^\d$/.test(value);
  }

  private moveToNextElement() {
    // Ascend the DOM from the current input until the parent container (date-container) is found
    const parentContainer = this.el.nativeElement.closest('.date-container');

    if (parentContainer) {
      const elements = Array.from(parentContainer.querySelectorAll('input'));
      if (this.index >= 0 && this.index < elements.length - 1) {
        const nextElement = elements[this.index + 1] as HTMLInputElement;
        nextElement.focus();
      }
    }
  }
}
